"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getTimeZone_1 = require("../services/getTimeZone");
var setSupportedTimeZones_1 = require("../data/mutators/setSupportedTimeZones");
function loadTimeZoneOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTimeZone_1.default().then(function (timeZones) {
                        setSupportedTimeZones_1.default(timeZones);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = loadTimeZoneOptions;
//# sourceMappingURL=loadTimeZoneOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/orchestration/loadTimeZoneOptions.js
// module id = 3725
// module chunks = 2